import { supabase } from "./supabase.js";

// Cache the token so API calls made immediately after onAuthStateChange
// don't race against getSession() localStorage persistence.
let _cachedToken = "";

export function setApiToken(token: string) {
  _cachedToken = token;
}

async function getToken(): Promise<string> {
  if (_cachedToken) return _cachedToken;
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return session?.access_token ?? "";
}

async function request<T>(
  url: string,
  opts: RequestInit = {}
): Promise<T> {
  const token = await getToken();
  const res = await fetch(url, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...opts.headers,
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }
  return res.json();
}

export const api = {
  get: <T>(url: string) => request<T>(url),
  post: <T>(url: string, body?: any, opts?: RequestInit) =>
    request<T>(url, {
      ...opts,
      method: "POST",
      body: body ? JSON.stringify(body) : undefined,
    }),
  put: <T>(url: string, body?: any, opts?: RequestInit) =>
    request<T>(url, {
      ...opts,
      method: "PUT",
      body: body ? JSON.stringify(body) : undefined,
    }),
  patch: <T>(url: string, body?: any, opts?: RequestInit) =>
    request<T>(url, {
      ...opts,
      method: "PATCH",
      body: body ? JSON.stringify(body) : undefined,
    }),
  del: <T>(url: string) => request<T>(url, { method: "DELETE" }),
};
